<template>
  <div class="btn-group">
    <button v-if="canApprove && ! isApproved" class="btn btn-purple btn-sm" @click="approve">
      <el-tooltip content="Start approving" placement="top" effect="light">
        <i class="fas fa-file-import"></i>
      </el-tooltip>
    </button>
    <button v-if="canDelete && ! isApproved" class="btn btn-danger btn-sm" @click="confirmDeleting">
      <el-tooltip content="Delete" placement="top" effect="light">
        <i class="fas fa-trash-alt"></i>
      </el-tooltip>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {boolean}
     */
    canApprove() {
      return this.row.canApprove;
    },

    /**
     * @return {boolean}
     */
    canDelete() {
      return this.row.canDelete;
    },

    /**
     * @returns {string}
     */
    approveUrl() {
      return this.row.approveUrl;
    },

    /**
     * @return {string}
     */
    deleteUrl() {
      return this.row.deleteUrl;
    },

    /**
     * @return {boolean}
     */
    isApproved() {
      return Boolean(_.get(this.row, 'model.is_approved'));
    },
  },

  methods: {
    /**
     * @event approve
     */
    approve() {
      this.$emit('approve', {url: this.approveUrl});
    },

    /**
     * @event delete
     */
    confirmDeleting() {
      this.$confirm('Are you sure you want to delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => null);
    },
  },
}
</script>
